import { LOC_ATTRIBUTE_CHANGE, LOC_CHANGED_ATTRIBUTE } from "../../locKeys";
import { Action } from "./Action";

const SYSDATE_WILDCARD = "#SYSDATE";
const SYSDATETIME_WILDCARD = "#SYSDATETIME";
const SYSTIME_WILDCARD = "#SYSTIME";

export class SetAttribute extends Action {
    public attrName: string;
    public value: string | null;
    public valueType: SetAttributeValueType;

    constructor(attrName: string, value: string | null, valueType: string, condition: string, comment: string) {
        super(condition, comment);

        this.attrName = attrName;
        this.valueType = SetAttribute._getValueType(value, valueType);
        this.value = SetAttribute._getValue(value, this.valueType);
    }

    public override async validate(): Promise<void> {
        if (!this.attrName)
            throw new Error(await this.getActionErrorMessage(LOC_CHANGED_ATTRIBUTE, LOC_ATTRIBUTE_CHANGE));
    }

    private static _getValueType(valueFromXml: string | null, stringValueType: string): SetAttributeValueType {
        const upperCaseValue = valueFromXml?.toUpperCase();
        const valueType = (SetAttributeValueType as any)[stringValueType];

        if (valueType === SetAttributeValueType.sysDate || upperCaseValue === SYSDATE_WILDCARD)
            return SetAttributeValueType.sysDate;

        if (valueType === SetAttributeValueType.sysDateTime || upperCaseValue === SYSDATETIME_WILDCARD)
            return SetAttributeValueType.sysDateTime;

        if (valueType === SetAttributeValueType.sysTime || upperCaseValue === SYSTIME_WILDCARD)
            return SetAttributeValueType.sysTime;

        if (valueFromXml === null || valueFromXml === "")
            return SetAttributeValueType.typedValue;

        return SetAttributeValueType.untypedValue;
    }

    private static _getValue(valueFromXml: string | null, valueType: SetAttributeValueType): string | null {
        if (valueType === SetAttributeValueType.sysDate)
            return SYSDATE_WILDCARD;
        if (valueType === SetAttributeValueType.sysDateTime)
            return SYSDATETIME_WILDCARD;
        if (valueType === SetAttributeValueType.sysTime)
            return SYSTIME_WILDCARD;

        return valueFromXml;
    }
}

// Typ nové hodnoty, musí lowerCase!
export enum SetAttributeValueType {
    sysDate = "sysDate",
    sysDateTime = "sysDateTime",
    sysTime = "sysTime",
    typedValue = "typedValue",
    untypedValue = "untypedValue",
}
